import { render, staticRenderFns } from "./requests.vue?vue&type=template&id=0ef460cf&scoped=true&"
import script from "./requests.vue?vue&type=script&lang=js&"
export * from "./requests.vue?vue&type=script&lang=js&"
import style0 from "./requests.vue?vue&type=style&index=0&id=0ef460cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef460cf",
  null
  
)

export default component.exports